import { createAction } from '@reduxjs/toolkit';
export const FETCH_ANALYTIC_TEAM_DATA = 'FETCH_ANALYTIC_TEAM_DATA';
export const fetchAnalyticTeamDataAction = createAction(FETCH_ANALYTIC_TEAM_DATA);